import { LoggingService } from '@instinet-analytics/core-lib';
import { LogMessagesStoreWriter } from 'logging/store/LogMessagesStoreWriter';
import { LogMessagesStoreService } from 'logging/store/LogMessagesStoreService';
import { getGlobalWindowVariables } from 'utils/globalWindowVariables';

function getOverridenLevelFromGlobalVariables(): string | undefined {
    return getGlobalWindowVariables().logLevel;
}

export function createLoggingService(
    logMessagesStoreService: LogMessagesStoreService
) {
    return new LoggingService({
        extraWriters: [new LogMessagesStoreWriter(logMessagesStoreService)],
        getOverriddenLevels: getOverridenLevelFromGlobalVariables,
    });
}
